import { useCurrentUser, type BuyParams } from "@indietabletop/appkit";
import type { ReactNode } from "react";
import { Link, useSearchParams } from "wouter";
import { href } from "../App/href";
import { button } from "../common.css";
import { banner } from "./ShopPage.css.ts";

export function ActionBanner(props: {
  matchParam: BuyParams["note"];
  heading: ReactNode;
  nudge: ReactNode;
  action: ReactNode;
}) {
  const { matchParam, heading, nudge, action } = props;
  const [params] = useSearchParams();
  const noteParamValue = params.get("note");

  if (matchParam !== noteParamValue) {
    return null;
  }

  return (
    <div className={banner.container}>
      <div className={banner.content}>
        <div>
          <div className={banner.heading}>{heading}</div>
          <div className={banner.nudge}>{nudge}</div>
        </div>

        {action}
      </div>
    </div>
  );
}

export function LoginNeededBanner(props: {
  backTo: string;
  redirectTo: string;
}) {
  const { backTo, redirectTo } = props;
  const currentUser = useCurrentUser();

  // This banner is only relevant if the user is not logged in.
  if (currentUser) {
    return null;
  }

  return (
    <ActionBanner
      matchParam="loginNeeded"
      heading="Not logged in"
      nudge="Log in to download your content."
      action={
        <Link
          href={href("~/login", { search: { backTo, redirectTo } })}
          className={button({ size: "small" })}
        >
          Log in
        </Link>
      }
    />
  );
}
